/**
 * Scroll suave global (Lenis) — desktop. En mobile: scroll nativo del navegador.
 */
(function () {
  var root = document.documentElement;
  if (!root.classList.contains('site-1925')) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (root.classList.contains('shopify-design-mode')) return;

  /* Mismo breakpoint que header mobile (989px): Lenis solo en desktop */
  var DESKTOP_MQ = window.matchMedia('(min-width: 990px)');
  var lenisRafId = null;
  var listenersBound = false;

  var PREVENT_SELECTOR =
    '.cart-drawer, .drawer, .menu-drawer, #CartDrawer, .facets, .localization-form, [data-lenis-prevent]';

  function isDesktopSmooth() {
    return DESKTOP_MQ.matches;
  }

  function isInsideSlider1925(node) {
    return !!(node && node.closest && node.closest('.slider-1925'));
  }

  function shouldPreventScroll(node) {
    if (!node || !(node instanceof HTMLElement)) return false;
    if (isInsideSlider1925(node)) return false;
    if (node.hasAttribute('data-lenis-prevent')) return true;
    if (node.matches && node.matches(PREVENT_SELECTOR)) return true;

    var style = window.getComputedStyle(node);
    var overflowY = style.overflowY;
    var scrollableY =
      (overflowY === 'auto' || overflowY === 'scroll') && node.scrollHeight > node.clientHeight + 1;

    return scrollableY;
  }

  function markPreventTargets() {
    document.querySelectorAll(PREVENT_SELECTOR).forEach(function (el) {
      if (isInsideSlider1925(el)) return;
      el.setAttribute('data-lenis-prevent', '');
    });
  }

  function getHeaderOffset() {
    var raw = getComputedStyle(root).getPropertyValue('--header-height');
    var px = parseFloat(raw);
    return -((isNaN(px) ? 80 : px) + 16);
  }

  function scrollToHash(hash, immediate) {
    if (!hash || hash === '#') return false;
    var target = document.querySelector(hash);
    if (!target) return false;

    var lenis = window.lenis1925;
    var offset = getHeaderOffset();
    var useImmediate = immediate || !isDesktopSmooth();

    if (lenis && typeof lenis.scrollTo === 'function') {
      lenis.scrollTo(target, { offset: offset, immediate: useImmediate });
      return true;
    }

    target.scrollIntoView({ behavior: useImmediate ? 'auto' : 'smooth', block: 'start' });
    return true;
  }

  function scrollToHashOnLoad() {
    var hash = window.location.hash;
    if (!hash || hash === '#') return;

    function run() {
      scrollToHash(hash, true);
    }

    requestAnimationFrame(function () {
      requestAnimationFrame(run);
    });

    window.setTimeout(run, 400);
  }

  function onHashLinkClick(event) {
    var link = event.target.closest('a[href*="#"]');
    if (!link || !link.hash) return;

    var targetUrl;
    try {
      targetUrl = new URL(link.href, window.location.href);
    } catch (e) {
      return;
    }

    if (!targetUrl.hash || targetUrl.hash === '#') return;

    var currentUrl = new URL(window.location.href);
    var samePage =
      targetUrl.origin === currentUrl.origin &&
      targetUrl.pathname === currentUrl.pathname &&
      targetUrl.search === currentUrl.search;

    if (!samePage) return;

    var target = document.querySelector(targetUrl.hash);
    if (!target) return;

    event.preventDefault();
    event.stopPropagation();

    scrollToHash(targetUrl.hash, !isDesktopSmooth());
    history.replaceState(null, '', targetUrl.pathname + targetUrl.search + targetUrl.hash);
  }

  function startLenisRaf(lenis) {
    function raf(time) {
      lenis.raf(time);
      lenisRafId = requestAnimationFrame(raf);
    }
    lenisRafId = requestAnimationFrame(raf);
  }

  function destroyLenis() {
    if (lenisRafId) {
      cancelAnimationFrame(lenisRafId);
      lenisRafId = null;
    }

    var lenis = window.lenis1925;
    if (lenis) {
      if (typeof lenis.destroy === 'function') lenis.destroy();
      window.lenis1925 = null;
    }

    root.classList.remove('lenis', 'lenis-smooth', 'lenis-stopped');
  }

  function initLenis() {
    if (!isDesktopSmooth() || typeof Lenis === 'undefined' || window.lenis1925) return;

    markPreventTargets();

    var lenis = new Lenis({
      duration: 1.1,
      lerp: 0.1,
      smoothWheel: true,
      wheelMultiplier: 0.9,
      touchMultiplier: 1.15,
      syncTouch: false,
      prevent: shouldPreventScroll,
    });

    window.lenis1925 = lenis;

    if (typeof lenis.on === 'function' && !document.body.classList.contains('template-home-1925')) {
      var lenisPrevY = lenis.scroll;
      lenis.on('scroll', function (payload) {
        var y = payload && typeof payload.scroll === 'number' ? payload.scroll : lenis.scroll;
        if (y < 1 && lenisPrevY >= 1 && y > 0.01) {
          lenis.scrollTo(0, { immediate: true });
        }
        lenisPrevY = y;
      });
    }

    startLenisRaf(lenis);
  }

  function bindListeners() {
    if (listenersBound) return;
    listenersBound = true;

    document.addEventListener('click', onHashLinkClick, true);
    window.addEventListener('hashchange', function () {
      scrollToHash(window.location.hash, !isDesktopSmooth());
    });
  }

  function setupScrollMode() {
    if (isDesktopSmooth()) {
      initLenis();
    } else {
      destroyLenis();
    }
  }

  bindListeners();
  setupScrollMode();

  if (typeof DESKTOP_MQ.addEventListener === 'function') {
    DESKTOP_MQ.addEventListener('change', setupScrollMode);
  } else if (typeof DESKTOP_MQ.addListener === 'function') {
    DESKTOP_MQ.addListener(setupScrollMode);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupScrollMode);
  }

  window.addEventListener('load', scrollToHashOnLoad);
})();
